export default {
  // 设备仓库的searchList
  commonSearchList: {
    terminalModel: 'Equipment type',
    terminalStatus: 'Equipment status',
    searchKeyword: 'Keyword search'
  },
  commonBtnList: {
    refresh: 'Refresh',
    clear: 'Clear'
  },
  commonTableBtns: {
    enable: 'enable'
  },
  commonTableBtnsMore: {
    putIn: 'Warehouse entry',
    repair: 'Repair',
    scrap: 'Scrap',
    set: 'Set Up',
    test: 'Recruitment and testing',
    info: 'Particulars'
  },
  // 公共的表格表头
  commonTableHeader: {
    onLineName: 'Online/Offline',
    equipmentProvider: 'Manufacturer code',
    statusName: 'Equipment status',
    sortId: 'Equipment serial number',
    terminalName: 'Equipment name',
    terminalModel: 'Equipment model',
    terminalSn: 'Equipment serial number',
    terminalImsi: 'Device IMSI card number',
    areaInfo: 'Location Area',
    terminalAddr: 'Installation location'
  }
};